<template>
  <section class="md:absolute left-full ml-5">
    <div
      class="
        circle-full
        w-6
        h-6
        bg-velux-grey-900
        rounded-full
        text-velux-white text-sm
        flex
        items-center
        justify-center
        cursor-pointer
      "
      @click.stop="
        isOpen = true;
        trackTooltip();
      "
    >
      <i class="fas fa-info"></i>
    </div>
    <div
      style="z-index: 1002"
      :class="{ hidden: !isOpen }"
      class="
        fixed
        left-0
        right-0
        top-0
        bottom-0
        w-full
        h-full
        flex
        items-center
        justify-center
      "
    >
      <div
        @click.stop="isOpen = false"
        class="absolute w-full h-full bg-opacity-50 bg-velux-grey-900 z-1"
      ></div>

      <div
        @click.stop=""
        class="
          max-h-screen
          overflow-auto
          bg-velux-white
          max-w-2xl
          px-6
          md:px-24 
          pt-16 pb-8
          relative
          z-10
        "
      >
        <div
          @click.stop="isOpen = false"
          class="
            text-xl
            md:text-2xl
            text-velux-grey-800
            opacity-80
            cursor-pointer
            w-8
            h-8
            flex
            items-center
            justify-center
            absolute
            right-4
            md:right-8
            top-3
            md:top-4
          "
        >
          <i class="far fa-times sticky top-4 flex-shrink-0"></i>
        </div>
        <h2 v-html="settings.TooltipTitle"></h2>
        <p v-html="settings.TooltipBody"></p>
      </div>
    </div>
  </section>
</template>

<script>
import tracking from "../../mixins/tracking";

export default {
  props: {
    isVisible: Boolean,
    settings: {}
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    trackTooltip() {
      tracking({
        eventAction: "More info on",
        eventLabel: this.settings.SalesforcePropertyValue
      });
    }
  }
};
</script>
